module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-epigraph element-without-heading",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-text"
    }
  }, [_c('div', {
    staticClass: "blockquote-container prose with-attribution"
  }, [_c('blockquote', {
    staticClass: "prose with-attribution"
  }, [_c('div', {
    staticClass: "paragraph-and-attribution"
  }, [_c('p', {
    staticClass: "first blockquote-content blockquote-content-prose blockquote-position-first"
  }, [_c('i', [_vm._v("“If you only knew the magnificence of the three, six, and nine, you would have a key to the universe.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-attribution blockquote-position-last"
  }, [_vm._v("Nikola Tesla, 1856 - 1943")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "paragraph-and-attribution"
  }, [_c('p', {
    staticClass: "first blockquote-content blockquote-content-prose"
  }, [_c('i', [_vm._v("“…I have created a Ball Lightning, which can be heard on the icy peaks of the Himalayas.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-attribution blockquote-position-last"
  }, [_vm._v("Nikola Tesla")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18a0d7e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 72
// module chunks = 0